export default __webpack_public_path__ + "static/media/phoneBlack.21565f11.svg";